// extracted by mini-css-extract-plugin
var _1 = "CommentTimestamp-module__animateUploadProgressBarWidth--bHYeo";
var _2 = "CommentTimestamp-module__animatedBackground--WIwK4";
var _3 = "CommentTimestamp-module__timestamp--aEUJa";
var _4 = "CommentTimestamp-module__timestampButton--LMe7i";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "timestamp", _4 as "timestampButton" }
